import { Close, DragIndicator, ExpandMore, SystemUpdateAlt, TextRotateVertical } from '@mui/icons-material';
import { Button } from '@mui/material';
import {
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarDensitySelector,
    GridToolbarExport,
    GridToolbarFilterButton
} from '@mui/x-data-grid-pro';

export type GridToolbarProps = {
    ToolbarButtons?: () => JSX.Element;
    rowReorder?: boolean;
    onSaveReorder?: () => void;
    toggleReorder?: () => void;
    onAlphabeticalOrder?: () => void;
    isReordering?: boolean;
    loadingReorder: boolean;
    handleShowImportDialog?: () => void;
};

export const GridToolbar = ({
    ToolbarButtons,
    onSaveReorder,
    onAlphabeticalOrder,
    rowReorder,
    toggleReorder,
    isReordering,
    loadingReorder,
    handleShowImportDialog
}: GridToolbarProps) => (
    <GridToolbarContainer sx={{ gap: 0.5 }}>
        <GridToolbarColumnsButton
            sx={({ palette }) => ({
                color: palette.primary[400],
                backgroundColor: palette.primary[300],
                borderRadius: '30px',
                padding: '8px 16px'
            })}
            endIcon={<ExpandMore />}
        />
        <GridToolbarFilterButton
            sx={({ palette }) => ({
                color: palette.primary[400],
                backgroundColor: palette.primary[300],
                borderRadius: '30px',
                padding: '8px 16px'
            })}
            componentsProps={{ button: { endIcon: <ExpandMore /> } }}
        />
        <GridToolbarDensitySelector
            sx={({ palette }) => ({
                color: palette.primary[400],
                backgroundColor: palette.primary[300],
                borderRadius: '30px',
                padding: '8px 16px'
            })}
            endIcon={<ExpandMore />}
        />
        <GridToolbarExport
            sx={(theme: { palette: { primary: any[] } }) => ({
                color: theme.palette.primary[400],
                backgroundColor: theme.palette.primary[300],
                borderRadius: '30px',
                padding: '8px 16px'
            })}
            endIcon={<ExpandMore />}
        />
        {handleShowImportDialog && (
            <Button
                onClick={handleShowImportDialog}
                sx={({ palette }) => ({
                    color: palette.primary[400],
                    backgroundColor: palette.primary[300],
                    borderRadius: '30px',
                    padding: '8px 16px'
                })}
                startIcon={<SystemUpdateAlt />}
                size="medium"
                color="primary"
            >
                Import
            </Button>
        )}
        {ToolbarButtons && <ToolbarButtons />}
        {!!rowReorder && isReordering && (
            <>
                <Button
                    onClick={onSaveReorder}
                    disabled={loadingReorder}
                    sx={({ palette }) => ({
                        color: palette.primary[400],
                        backgroundColor: palette.primary[300],
                        borderRadius: '30px',
                        padding: '8px 16px'
                    })}
                    startIcon={<DragIndicator />}
                    size="medium"
                    color="primary"
                >
                    Save order
                </Button>
                {onAlphabeticalOrder && (
                    <Button
                        onClick={onAlphabeticalOrder}
                        disabled={loadingReorder}
                        sx={({ palette }) => ({
                            color: palette.primary[400],
                            backgroundColor: palette.primary[300],
                            borderRadius: '30px',
                            padding: '8px 16px'
                        })}
                        startIcon={<TextRotateVertical />}
                        size="medium"
                        color="primary"
                    >
                        Alphabetical order
                    </Button>
                )}
                <Button
                    onClick={toggleReorder}
                    disabled={loadingReorder}
                    sx={({ palette }) => ({
                        color: palette.primary[400],
                        backgroundColor: palette.primary[300],
                        borderRadius: '30px',
                        padding: '8px 16px'
                    })}
                    startIcon={<Close />}
                    size="medium"
                    color="primary"
                >
                    Cancel
                </Button>
            </>
        )}
        {!!rowReorder && !isReordering && (
            <Button
                onClick={toggleReorder}
                sx={({ palette }) => ({
                    color: palette.primary[400],
                    backgroundColor: palette.primary[300],
                    borderRadius: '30px',
                    padding: '8px 16px'
                })}
                startIcon={<DragIndicator />}
                size="medium"
                color="primary"
            >
                Edit order
            </Button>
        )}
    </GridToolbarContainer>
);
